<template>
  <tela-component title="Relatório Posição Contratos">
    <v-card flat rounded="lg">
      <v-card-text>
        <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
        <template>
          <v-select
            label="Representante/Vendedor"
            no-data-text="Nenhuma opção disponível"
            :items="vendedores"
            item-value="codigo"
            item-text="nome"
            v-model="vendedorSelecionado"            
          ></v-select>

          <v-select
            label="Tipo Relatório"
            :items="tiposRelat"
            item-text="descricao"
            item-value="cod"
            no-data-text="Nenhum tipo de relatório encontrado"
            v-model="tipoRelatSelec"
          ></v-select>
          <v-btn rounded block color="info" depressed @click="gerarRelatorio()"
            >Gerar Relatório</v-btn
          >
        </template>
      </v-card-text>
    </v-card>
  </tela-component>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TelaComponent from "../tela/TelaComponent.vue";
export default {
  components: { TelaComponent },
  computed: {
    ...mapState("usuario", ["usuarioLogado"]),
    ...mapState("base", ["vendedores"]),
  },
  data: () => ({
    tiposRelat: [
      { cod: 1, descricao: "Geral" },
      { cod: 2, descricao: "Por Produto" },
    ],
    tipoRelatSelec: 1,
    loading: true,
    vendedorSelecionado: 0,
  }),
  methods: {
    ...mapActions("base", ["getVendedores"]),
    gerarRelatorio() {
      window.open(
        `${process.env.VUE_APP_BASE_URL}/nutricao-animal/clientes/produtos-em-aberto?token=${this.usuarioLogado.token}&sync=true&output=PDF&tiporelat=${this.tipoRelatSelec}&cod_vendedor=${this.vendedorSelecionado}`,
        "_blank"
      );
    },   
  },
  async mounted() {
    this.loading = true;
    await this.getVendedores();    
    this.vendedorSelecionado = this.vendedores[0]
    this.loading = false;
  },
};
</script>

<style>
</style>